import { RecommendedAction } from "@oldDashboard/legacyModels/recommendedAction.model";
import { RecommendedActionSerializer } from "@oldDashboard/legacyModels/serializers/recommendedActionSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandRecommendedActions {
    async run(affiliateId: String, launchSelected: String, timePeriodSelected: String, sort: String) {  
        const path = `get-chart-data/client:launch-recommended-actions/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&sort=${sort}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): RecommendedAction{
        const serializer = new RecommendedActionSerializer();
        return serializer.deserialize(data);
    }
}

